import { CONFIG } from "@/config";
var SOUNDTRACK = CONFIG.soundtrack;
export var Tracklist = SOUNDTRACK == null
    ? []
    : SOUNDTRACK.tracks.map(function (_a, i) {
        var title = _a.title, duration = _a.duration;
        SOUNDTRACK.folder.keys();
        return {
            title: title,
            duration: duration,
            audio: SOUNDTRACK.folder(SOUNDTRACK.folder.keys()[i]),
        };
    });
